import _sfc_main from './select-list.vue.js';
/* empty css                 */
import _export_sfc from '../../_virtual/_plugin-vue_export-helper.js';

const selectList = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-7e0481ec"]]);

export { selectList as default };
//# sourceMappingURL=select-list.js.map
